var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      align: "right"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.batchAudit
    }
  }, [_vm._v("批量审核")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题",
      width: "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-community-table-link", {
          attrs: {
            id: scope.row.objId,
            token: scope.row.objId,
            title: scope.row.title
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "otherUser.name",
      label: "被评论人",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          otherUser = _ref$row.otherUser,
          otherUserInfo = _ref$row.otherUserInfo;
        return [otherUser.type ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: otherUser.color
          }
        }, [_vm._v(_vm._s(otherUser.label))]) : _vm._e(), _c("wlc-user-pop", {
          attrs: {
            info: otherUserInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.name",
      label: "评论人",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var _ref2$row = _ref2.row,
          user = _ref2$row.user,
          userInfo = _ref2$row.userInfo;
        return [user.type ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: user.color
          }
        }, [_vm._v(_vm._s(user.label))]) : _vm._e(), _c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "content",
      label: "评论内容"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "评论时间",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删除")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };